// assets/slider-mobile-nav.js
(function () {
  function setup(root) {
    if (root.__mobNavReady) return;
    root.__mobNavReady = true;

    const btnPrev = root.querySelector('.slider-mobnav__prev');
    const btnNext = root.querySelector('.slider-mobnav__next');
    const counterCurrent = root.querySelector('.slider-mobcounter .mobcounter-current');
    const counterTotal = root.querySelector('.slider-mobcounter .mobcounter-total');

    let list = null;            // <ul class="slider">
    let slides = [];            // live slides array
    let isAnimating = false;
    let targetLeft = 0;

    const clamp = (i) => Math.max(0, Math.min(getSlides().length - 1, i));

    function queryList() {
      return root.querySelector('ul.slider');
    }
    function getSlides() {
      return list ? Array.from(list.querySelectorAll('.slider__slide')) : [];
    }
    function getIndexFromScroll() {
      if (!list) return 0;
      const x = list.scrollLeft;
      let best = 0, d = Infinity;
      getSlides().forEach((s, i) => {
        const dist = Math.abs(s.offsetLeft - x);
        if (dist < d) { d = dist; best = i; }
      });
      return best;
    }
    function getIdxFromActive() {
      return getSlides().findIndex(s => s.classList.contains('is-active'));
    }
    function updateButtons(idx) {
      const last = getSlides().length - 1;
      btnPrev?.classList.toggle('is-disabled', idx <= 0);
      btnNext?.classList.toggle('is-disabled', idx >= last);
    }
    function updateCounter(idx) {
      if (counterCurrent) counterCurrent.textContent = String(idx + 1);
      if (counterTotal) counterTotal.textContent = String(getSlides().length);
    }

    function setActive(i, smooth = true) {
      const idx = clamp(i);
      slides = getSlides();
      slides.forEach((s, k) => s.classList.toggle('is-active', k === idx));
      if (slides[idx]) {
        targetLeft = slides[idx].offsetLeft;
        isAnimating = smooth;
        list.scrollTo({ left: targetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
      updateCounter(idx);
      updateButtons(idx);
      if (!smooth) isAnimating = false;
    }

    function onScroll() {
      // while we animate, ignore our own scroll events
      if (isAnimating) {
        if (Math.abs(list.scrollLeft - targetLeft) < 2) isAnimating = false;
        return;
      }
      const idx = getIndexFromScroll();
      getSlides().forEach((s, k) => s.classList.toggle('is-active', k === idx));
      updateCounter(idx);
      updateButtons(idx);
    }

    function refresh() {
      const newList = queryList();
      if (!newList) return;

      // if UL replaced, attach listener again
      if (list !== newList) {
        if (list) list.removeEventListener('scroll', onScroll);
        list = newList;
        list.addEventListener('scroll', onScroll, { passive: true });
      }

      slides = getSlides();
      if (counterTotal) counterTotal.textContent = String(slides.length);

      // prefer theme’s active slide; otherwise nearest to scroll
      const idx = (() => {
        const a = getIdxFromActive();
        return a >= 0 ? a : getIndexFromScroll();
      })();

      setActive(idx, false);
    }

    // Clicks: refresh state first, then move one step
    btnPrev?.addEventListener('click', () => { refresh(); setActive(getIndexFromScroll() - 1); });
    btnNext?.addEventListener('click', () => { refresh(); setActive(getIndexFromScroll() + 1); });

    // Re-sync when variant/swatch changes (covers radios & selects)
    root.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"], select')) {
        // Section updates can be async; run twice for safety
        setTimeout(refresh, 60);
        setTimeout(refresh, 300);
      }
    });

    // Also watch for DOM changes (some themes mutate the gallery on variant change)
    const mo = new MutationObserver(() => {
      const ul = queryList();
      if (ul && (ul !== list || ul.children.length !== slides.length)) refresh();
    });
    mo.observe(root, { childList: true, subtree: true });

    // Initial sync
    refresh();
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(setup);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
